(function () {
    'use strict';

    angular
        .module('app')
        .controller('HelpController', HelpController);

    function HelpController($scope, $state, toaster, PLMHelpFile, cfpLoadingBar) {
        var model = this;
        model.plmHelpFile = PLMHelpFile;

        cfpLoadingBar.complete();

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }
        /*
        model.patternNonSeasonalFields = [
            "PatternId",
            "BrandId",
            "Name",
            "ImageName",
            "OutsoleImageName",
            "ImagePath",
            "OutsoleImagePath",
            "AdoptedStatus",
            "AdoptedDate",
            "AdoptedBy",
            "EstCompleteDate",
            "ActCompleteDate",
            "ReferencePattern",
            "ApprovalNumber",
            "Stage1",
            "Stage2",
            "Stage3",
            "DevRefName",
            //"DivisionKey",
            //"Division",
            "PatternNameKey",
            "PatternName",
            "PatternDesc",
            "LastNameKey",
            "LastName",
            "LastDescr",
            "NewLastYN",
            "MktgOutsoleNm",
            "FabBtmOutsole",
            "HeelHeight",
            "ShaftHeight",
            "ShaftCircum",
            "Offset",
            "ForefootHght",
            "DiamAlphaNum",
            "ActivityType",
            "ActivityKey",
            "ProductLine",
            "SeasonalPrgm",
            "CustomerKey",
            "CustomerNam",
            "ConsumSupport",
            "InStorePgrm",
            "TechCallout",
            "SellinSuprt",
            "VeganFriend",
            "ConstructionKey",
            "Construction",
            "GenderKey",
            "Gender",
            "CollectionNum",
            "CollectionDesc",
            "HierCodeLev1Key",
            "HierCodeLev2Desc",
            "MatlFrGrpKy",
            "MatlFrGrpDesc",
            "Developer",
            "SourcDeveloper",
            "Designer",
            "FactAccessKey",
            "FactAccessName",
            "RetailPrice",
            "WsPrice",
            "BusinessSeg",
            "VibramYN",
            "CompoundKy",
            "CompounDesc",
            "Waterproof",
            "Membrane",
            "MembrnSupp",
            "MembrnKey",
            "MembraneDesc",
            "MembrnPckg",
            "BootieYn",
            "SeamSldYn",
            "UpperLining",
            "MidsleOutsle",
            "GenNotes",
            "ContrctDesigner",
            "Colorist",
            "SBU",
            "PlanningCatDesc",
            "PlanningCatKey",
            "SampleWeight",
            "CreatedOn",
            "SBUKey",
            "IsLocked",
            "CreatedBy",
            "ChangedOn",
            "ChangedBy",
            "PTAStatus",
            "PTAAuthDate",
            "PTAAuthBy",
            "legacyGUID"
        ];

        model.patternSeasonalFields = [
            "PatternSeasonalId",
            "PatternId",
            "SeasonId",
            "StatusId",
            "ResponsibleId",
            "DropDate",
            "EarliestLaunch",
            "NewKnivesYN",
            "TargetPurPrice",
            "StyleMin",
            "ProjPattVol",
            "DualSrcdPatt",
            "USVolume",
            "CAVolume",
            "EmeaOwnedVolume",
            "EmeaDistVolume",
            "NaDtcStoreVolume",
            "NaDtcEcomVolume",
            "ItalyVolume",
            "Emea3pVolume",
            "AsiaVolume",
            "C4CVolume",
            "LatinAVolume",
            "IntnlVolume",
            "TotalVolume",
            "OrigFOBTarget",
            "TargetNumColors",
            "TargetDtyUS",
            "USDutyFree",
            "TargetDtyCA",
            "TargetDtyUK",
            "TargetDtyEU",
            "FactoryTransfer",
            "IsUSFrcst",
            "IsCAFrcst",
            "IsEmeaOwnedFrcst",
            "IsEmeaDistFrcst",
            "IsNaDtcStoreFrcst",
            "IsEmea3pFrcst",
            "IsAsiaFrcst",
            "IsC4CFrcst",
            "IsLatinAFrcst",
            "IsIntlFrcst",
            "LinePlanLaunchDateId",
            "DevelopmentType",
            "OutsoleNumber",
            "OutsoleName",
            "OutsoleTechID",
            "OutsoleTechDesc",
            "MidsoleNumber",
            "MidsoleName",
            "CriticalPathDevPatternId",
            "WFGroupId",
            "IsDeleted",
            "CreatedOn",
            "CreatedBy",
            "ChangedOn",
            "ChangedBy",
            "IsNew",
            "EuDtcVolume",
            "IsEuDtcFrcst",
            "CNVolume",
            "IsCNFrcst",
            "HKVolume",
            "IsHKFrcst",
            "OutsoleId",
            "MidsoleId",
            "legacyGUID",
            "IsShifted"
        ];

        model.colorwayNonSeasonalFields = [
            "PrototypeId",
            "BrandId",
            "Name",
            "ImageName",
            "ImagePath",
            "ActComplDate",
            "CreatedOn",
            "DropDate",
            "FactRefNum",
            "DevColorNm",
            "SAPPattNmAbr",
            "ColorKey",
            "ColorDesc",
            "NRFColorKey",
            "NRFColorDesc",
            "ProdLine",
            "StockNum",
            "PictogrmLbl",
            "UpperDesc",
            "LiningDesc",
            "OutsoleDesc",
            "MatlGridNum",
            "MatlGridText",
            "ToeCompKey",
            "ToeCompDesc",
            "SafetyToe",
            "ToeRateKey",
            "QualCat",
            "Width",
            "SampWght",
            "PrePrdAuthDt",
            "PrePrdAuthNum",
            "ProdAuthDt",
            "ProdAuthNum",
            "GenNotes",
            "UsComp",
            "UsCompVal",
            "DualSrcdPatt",
            "BuyReady",
            "AgeCode",
            "FWS",
            "HierCodeLev1Key",
            "HierCodeLev1Desc",
            "ReferneceNumber",
            "CompStyleStockNumber",
            "EstCompleteDate",
            "ColorMinimum",
            "IsLocked",
            "DivisionKey",
            "Division",
            "CollectionNum",
            "CollectionDesc",
            "BusinessSeg",
            "CreatedBy",
            "ChangedOn",
            "ChangedBy",
            "legacyGUID",
            "PdmColorId",
            "BasicMaterial",
            "CustomerKey",
            "CustomerNam"
        ];

        model.colorwaySeasonalFields = [
            "PrototypeSeasonalId",
            "SeasonId",
            "UsHtsStawn",
            "UsAssignDuty",
            "UsHtsCodeKey",
            "CaHtsStawn",
            "CaAssignDuty",
            "CaHtsCodeKey",
            "UkHtsStawn",
            "UkAssignDuty",
            "UkHtsCodeKey",
            "EuHtsStawn",
            "EuAssignDuty",
            "EuHtsCodeKey",
            "StatusId",
            "ResponsibleId",
            "FactNameKy",
            "FactName",
            "CtryOfOrig",
            "EstFFC",
            "EstPurPrice",
            "FFC",
            "ActPurPrice",
            "CostingCompl",
            "ProductTypeId",
            "USVolume",
            "CAVolume",
            "EmeaOwnedVolume",
            "EmeaDistVolume",
            "NaDtcStoreVolume",
            "NaDtcEcomVolume",
            "ItalyVolume",
            "Emea3pVolume",
            "AsiaVolume",
            "C4CVolume",
            "LatinAVolume",
            "IntnlVolume",
            "TotalVolume",
            "Launch",
            "MitigAdjustment",
            "DualSrcdProto",
            "ColorMin",
            "EstFfcCurr",
            "FfcCurr",
            "EstFfcPct",
            "FfcPct",
            "ServFee",
            "FactoryTransfer",
            "HTSNotes",
            "IsUSFrcst",
            "IsCAFrcst",
            "IsEmeaOwnedFrcst",
            "IsEmeaDistFrcst",
            "IsNaDtcStoreFrcst",
            "IsEmea3pFrcst",
            "IsAsiaFrcst",
            "IsC4CFrcst",
            "IsLatinAFrcst",
            "IsIntlFrcst",
            "LinePlanLaunchDateId",
            "CreatedOn",
            "CreatedBy",
            "ChangedOn",
            "ChangedBy",
            "WFGroupId",
            "LDMPrice",
            "ISRPrice",
            "SMPrice",
            "SMFinalPrice",
            "LDMCompleteDate",
            "ISRCompleteDate",
            "SMCompleteDate",
            "SMFinalCmptDt",
            "RSComplete",
            "PerformanceLvl",
            "LDMComplete",
            "ISRComplete",
            "SMComplete",
            "SMFinalComplete",
            "SFOverride",
            "CriticalPathDevPrototypeId",
            "IsDeleted",
            "IsNew",
            "ConfSmplApprDt",
            "ConfNotes",
            "LthrApprvDate",
            "LthrApprvBy",
            "FinalSpecApprLockedDt",
            "FinalSpecApprLockedBy",
            "FinalCostConfCBDLoadDt",
            "FinalCostConfCBDLoadBy",
            "ThreeOneTestComplDt",
            "ThreeOneTestComplBy",
            "RSTestCompleteDt",
            "RSTestCompleteBy",
            "MatlRefFolderSignedDt",
            "MatlRefFolderSignedBy",
            "ConfSmpleAppBy",
            "IsSFOverride",
            "ReleasedOn",
            "ReleasedBy",
            "IsSpecLock",
            "BuyReady",
            "EuDtcVolume",
            "IsEuDtcFrcst",
            "CNVolume",
            "IsCNFrcst",
            "HKVolume",
            "IsHKFrcst",
            "legacyGUID",
            "InitialPrototypeComplete",
            "InitialPrototypeCompleteDate",
            "InitialPrototypePrice",
            "ConfSampSentBy",
            "ConfSampSentDt",
            "ModelSizeAppBy",
            "ModelSizeAppDt",
            "OutsoleTechCode",
            "IsShifted",
            "CostingComplDate",
            "CostingComplBy"
        ];
        */
    }
})();
